import type { LensState } from '~/pages/LeLens/document/types';

import { REPORTING_LE_LENSES_PATH } from '~/consts/reportingLeLensApi';

import { requestWithTimeout } from '~/utils/requestWithTimeout';
import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

import { encodedJsonBody } from './encodedJsonBody';
import { optionScopeKey, withoutParams } from './useGetReportingLensDocumentData';

export const PRELOADED_MEMBERS = 500;

export type MemberSearch = {
  key: ReadonlyArray<unknown>;
  load: (
    text: string,
    after: string | undefined,
    signal: AbortSignal,
  ) => Promise<{
    values: Array<string>;
    after?: string;
    complete?: boolean;
    status?: 'complete' | 'truncated' | 'error' | 'not_linked';
  }>;
};

export function lensFilterMembers(
  lens: { id: string; version: number },
  state: LensState,
  column: string,
  actorEmail?: string,
  tabs?: Array<string>,
  foldedParams: Array<string> = [],
): MemberSearch {
  const requestState = withoutParams(state, foldedParams);
  return {
    key: [
      'lens-filter-members',
      actorEmail?.trim().toLowerCase(),
      lens.id,
      lens.version,
      optionScopeKey(requestState),
      column,
      tabs,
    ],
    load: (text, after, signal) =>
      requestWithTimeout(
        resolveReportingLeLensUrl(`${REPORTING_LE_LENSES_PATH}/${encodeURIComponent(lens.id)}/filter-members`),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: encodedJsonBody({ lensVersion: lens.version, state: requestState, column, text, after, tabs }),
          signal,
        },
        'These choices are taking too long to load. Please try again.',
        90_000,
      ),
  };
}
